// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"472b8400","85":"53d30d7f","633":"0c1583cd","655":"788bde10","822":"0e16861b","886":"d0f92002","898":"58839cce"}[chunkId] + ".chunk.js";
};